export default __webpack_public_path__ + "static/media/arrow-down.564c0135.svg";